import React from 'react';
import { FiCheck } from 'react-icons/fi';
import SkillBadge from '../../../common/skillBadge';

// --- Reusable Sub-components specific to this view ---

const InfoItem = ({ label, value, children }) => (
  <div>
    <p className="text-xs text-gray-999">{label}</p>
    <div className="font-semibold text-gray-333">{value || children}</div>
  </div>
);

const DescriptionSection = ({ title, items }) => (
  <div className="mb-3 last:mb-0">
    <h3 className="text-sm font-bold mph-primary mb-3">{title}</h3>
    <ul className="space-y-2 text-xs text-gray-333">
      {items.map((item, index) => (
        <li key={index} className="flex items-start gap-1">
          <FiCheck className="mph-primary mt-1 flex-shrink-0" />
          <span>{item}</span>
        </li>
      ))}
    </ul>
  </div>
);
// --- The Main JobDetailContent Component ---

const JobDetailContent = ({ job }) => {
  return (
    <div className="bg-white rounded-2xl shadow-lg p-6">      
      <div className="flex justify-between items-center pb-3 border-b border-gray-100">
        <div>
            <h1 className="text-xl font-bold text-gray-333">{job.title}</h1>
            <p className="text-gray-999 text-sm">{job.company}</p>
        </div>
        <button className="flex items-center gap-2 profiler-bg font-semibold px-3 py-1.5 rounded-full text-xs">
            <FiCheck /> Apply now
        </button>
      </div>

      <div className="grid grid-cols-4 gap-y-6 gap-x-4 py-3 text-sm">
        <InfoItem label="Job ID" value={job.id} />
        <InfoItem label="Posted on" value={job.postedOn} />
        <InfoItem label="Location" value={job.location} />
        <InfoItem label="Experience required" value={job.experience} />
        <InfoItem label="Vacancies" value={job.vacancies} />
        <InfoItem label="Status" value={job.status} />
        <InfoItem label="Industry" value={job.industry} />
        <InfoItem label="Application Deadline">
          {job.deadline} <span className="text-red-500 font-bold">({job.deadlineCountdown})</span>
        </InfoItem>
        <InfoItem label="Category" value={job.category} />
        <InfoItem label="Languages Required">
          <div className="flex flex-wrap gap-2 mt-1">
            {job.languages.map(lang => <SkillBadge key={lang}>{lang}</SkillBadge>)}
          </div>
        </InfoItem>
        <InfoItem label="Skills Required">
          <div className="flex flex-wrap gap-2 mt-1">
            {job.skills.map(skill =><SkillBadge key={skill}>{skill}</SkillBadge>)}
          </div>
        </InfoItem>
      </div>

      <div className="mph-light rounded-xl p-6 mt-4">
        <DescriptionSection title="Experience Requirements" items={job.requirements} />
        <DescriptionSection title="Job Responsibilities" items={job.responsibilities} />
        <DescriptionSection title="Objectives" items={job.objectives} />
      </div>
    </div>
  );
};

export default JobDetailContent;